import React, { useState } from "react";
import { AcademyCourseData } from "../data/interface/CourseData";
import { AcademyCoursePageProps } from "../data/interface/AcademyCoursePageProps";
import "../styles/AcademyCoursePageStyles.css";
import LiveSessionBadge from "../components/LiveSessionTag";
import AgeCriteImg from "../../../assets/images/offereings_techbots/AgeCriteImg.png";
import { useNavigate } from "react-router-dom";
import academyLogo from "../../../assets/images/offereings_techbots/TechbotsAcademyLogo.png";
import roboQuestImg from "../../../assets/images/offereings_techbots/RoboQuestCardImg.png";

import Logger from "../../../utils/Logger";
import EnrollmentForm from "./OfferingEnrollPopupPage";
const AcademyCoursePage: React.FC<AcademyCoursePageProps> = ({
  academicData,
}) => {
  Logger.info(
    "path***************",
    academicData.course_list[0].course_thumbnail,
  );
  const navigate = useNavigate();
  const [showEnrollmentForm, setShowEnrollmentForm] = useState(false);
  const [selectedCourse, setSelectedCourse] =
    useState<AcademyCourseData | null>(null);
  const handleEnrollClick = (course: AcademyCourseData) => {
    if (course.is_enrolled) {
      setSelectedCourse(course);
      setShowEnrollmentForm(true);
    } else {
      navigate("/dashboard/offerings/courseDetail", {
        state: { courseData: course, academyData: academicData },
      });
    }
  };
  return (
    <div className="offerings-academy-container">
      {/* Enrollment Form Popup */}
      {showEnrollmentForm && selectedCourse && (
        <EnrollmentForm
          onClose={() => setShowEnrollmentForm(false)}
          courseTitle={selectedCourse.course_title}
        />
      )}
      <div className="offerings-academy-header">
        <img
          src={academyLogo}
          alt={academicData.academy_name}
          className="offerings-academy-logo"
        />
        <div>
          <p className="offerings-academy-nametext">
            {academicData.academy_name}
          </p>
          <p className="offerings-academy-proverbtext">
            {academicData.academey_proverb}
          </p>
        </div>
      </div>

      <p className="offerings-academy-descriptiontext">
        {academicData.academy_description}
      </p>
      <p
        className="offerings-academy-descriptiontext"
        style={{ paddingTop: "20px" }}
      >
        {academicData.acadmey_subdescription}
      </p>

      <div className="offerings-academy-courses">
        {academicData.course_list.map((course: any) => (
          <div
            key={course.course_title}
            className="offerings-academy-card"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              minHeight: "420px", // Adjust based on your tallest content
              padding: "16px",
              border: "1px solid #ccc",
              borderRadius: "10px",
            }}
          >
            <div style={{ position: "relative" }}>
              <img src={course.course_thumbnail} alt={course.course_title} />
              {course.is_live_session && <LiveSessionBadge />}
            </div>

            <p className="offerings-academy-course-titletext">
              {course.course_title}
            </p>

            <p
              className="offerings-academy-course-descrptext"
              style={{
                height: "60px", // Fixed height to align cards
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                marginBottom: "8px",
              }}
            >
              {course.course_description}
            </p>

            <p className="offerings-academy-agetext">
              <img
                src={AgeCriteImg}
                className="offerings-academy-ageimg"
                alt="Age Criteria"
              />
              Age Criteria: {course.age_criteria}
            </p>

            <button
              className="offerings-academy-button"
              style={{ marginTop: "auto" }}
              onClick={() => {
                if (course.is_enrolled === true) {
                  handleEnrollClick(course);
                } else {
                  navigate(
                    "/dashboard/offerings/techbotsacademy/courseDetail",
                    {
                      state: { courseData: course, academyData: academicData },
                    },
                  );
                }
              }}
            >
              {course.is_enrolled ? "Enroll" : "View Programs"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AcademyCoursePage;
